import { clsx } from 'clsx';
import { FC, MouseEvent } from 'react';
import { Card } from '../card/Card';
import { ListComponentBaseProps } from '../entity-list/interface';
import { useQuery } from '../request/hooks/useQuery';
import styles from './styles.module.scss';

export interface CardListItemBaseProps<D> {
  data: D;
  refresh?: VoidFunction;
  writeData?: ReturnType<typeof useQuery>['writeData'];
}

export function CardList<D extends object>({
  data,
  listRef,
  focusIndex,
  CardListItem,
  onCardClick,
  handleKeyPress,
  refresh,
  writeData
}: {
  CardListItem: FC<CardListItemBaseProps<D>>;
  onCardClick: (data: D, e: MouseEvent<HTMLButtonElement>) => void;
} & ListComponentBaseProps<D[]>) {
  return (
    <div role='button' ref={listRef} onKeyDown={handleKeyPress} tabIndex={0}>
      {data.map((item, index) => (
        <Card
          key={`${index.toString()}`}
          tag='button'
          dataId={index.toString()}
          onClick={e => {
            onCardClick(item, e as MouseEvent<HTMLButtonElement>);
          }}
          className={clsx(
            styles.card,
            index !== 0 && 'mt-3',
            focusIndex === index && styles.focused
          )}
        >
          <CardListItem data={item} refresh={refresh} writeData={writeData} />
        </Card>
      ))}
    </div>
  );
}
